import { withRouter } from 'react-router-dom';

import Slideout from './Slideout';

export default withRouter(Slideout);
